import { useQuery } from '@tanstack/react-query';
import tradeAPI from 'lib/api/trade';
import { TransactionHistoryParams } from 'global/Securities/types/api/history';

export const useGetOrderList = (gtc = 0, stock = '') =>
  useQuery({
    queryKey: ['orderList', stock],
    queryFn: async () => {
      const response = await tradeAPI.getOrderList(gtc, stock);
      return response.data.data;
    },
    onError: () => [],
  });

export const useGetOrderHistory = (params: TransactionHistoryParams) =>
  useQuery({
    queryKey: ['orderHistory', params],
    queryFn: async () => {
      const response = await tradeAPI.getHistory(params);
      return response.data.data;
    },
    onError: () => [],
  });
